
//import useState hook to create menu collapse state
import React, { useState } from "react";

//import react pro sidebar components
import {
    ProSidebar,
    Menu,
    MenuItem,
    SidebarHeader,
    SidebarFooter,
    SidebarContent,
} from "react-pro-sidebar";
import { FaUserLarge, FaPhone } from "react-icons/fa6";
import { TbUsersPlus } from "react-icons/tb";
import { RiGraduationCapLine } from "react-icons/ri";
import { HiUserCircle, HiCog } from "react-icons/hi";
import { FaBuilding } from 'react-icons/fa';
import { IoMail } from "react-icons/io5";

import { FiLogOut } from "react-icons/fi";
import InsightsIcon from '@mui/icons-material/Insights';
import BarChartIcon from '@mui/icons-material/BarChart';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import "react-pro-sidebar/dist/css/styles.css";
import "./sideBar.css";
import SessionService from "../services/SessionService";
import { useLocation, useNavigate } from "react-router-dom";


const SideBar = () => {

    //create initial menuCollapse state using useState hook
    const [menuCollapse, setMenuCollapse] = useState(false)

    //create a custom function that will change menucollapse state from false to true and true to false
    const menuIconClick = () => {
        //condition checking to change state from true to false and vice versa
        menuCollapse ? setMenuCollapse(false) : setMenuCollapse(true);
    };

    const location = useLocation();
    const { pathname } = location;
    const navigate = useNavigate();
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));
    const isFromCompanyList = localStorage.getItem('masterCompanyName') === 'bizcloudExperts';
    const analyticsMenuItem = { label: "Analytics", path: "/analytics", icon: <InsightsIcon style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> };
    const quicksightMenuItem = { label: "QuickSight Analytics", path: "/quicksight-analytics", icon: <BarChartIcon style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> };
    const usersMenuItem = { label: "Users", path: "/users", icon: <FaUserLarge style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> };
    // const requestItem = { label: "Requests", path: "/requests", icon: <RequestPageIcon style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> };

    const DEFAULT_APPLICATION = [
        // { label: "Modules/Pricing", path: "/modules-pricing", icon: <FaUserLarge style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> },
        { label: "Users Activity", path: "/user-activity", icon: <RiGraduationCapLine style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> },
        usersMenuItem,
        analyticsMenuItem,
        { label: "Referrals", path: "/referrals", icon: <TbUsersPlus style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> },
        { label: "Settings", path: "/settings", icon: <HiCog style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> }
    ]

    const COMPANY_LIST_APPLICATION = [
        { label: "Customers", path: "/company-list", icon: <FaBuilding style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} /> },
        usersMenuItem,
        analyticsMenuItem,
        // quicksightMenuItem,
        // requestItem
    ]

    const logout = () => {
        localStorage.clear();
        SessionService.setCompanyName('');
        navigate('/signin');
        window.location.reload();
    }

    const handleNavigate = (path) => {
        navigate(path);
    }
    const applicationLinks = isFromCompanyList ? COMPANY_LIST_APPLICATION : DEFAULT_APPLICATION;

    return (
        <div className="sidebar">
            <ProSidebar collapsed={menuCollapse} className="pro-sidebar-height">
                <SidebarHeader className="theme-bg" style={{ minHeight: '20vh' }}>
                    {!menuCollapse ? (
                        <div className='icon-container'>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                    <HiUserCircle style={{ fontSize: '50px', margin: "15px", color: "white" }} />
                                </div>
                                <div>
                                    <span>{userDetails?.first_name + " " + userDetails?.last_name}</span>
                                </div>
                            </div>
                            {userDetails?.email && (
                                <div className='ellipsis'><IoMail style={{ marginLeft: "20px", fontSize: "12px" }} /><span className='icon-names'>{userDetails?.email}</span></div>
                            )}
                            {userDetails?.phone && (
                                <div><FaPhone style={{ marginLeft: "20px", fontSize: "12px" }} /><span className='icon-names'>{userDetails?.phone}</span></div>
                            )}
                        </div>
                    ) : (
                        <HiUserCircle style={{ fontSize: '50px', margin: "15px", color: "white" }} />
                    )}
                </SidebarHeader>
                <SidebarContent className="theme-bg">
                    <Menu iconShape="square">
                        {applicationLinks.map((item, id) => (
                            <MenuItem
                                active={pathname === item.path}
                                className={"mt-3"}
                                onClick={() => handleNavigate(item.path)}
                            >
                                {item.icon} {item.label}
                            </MenuItem>
                        ))}
                    </Menu>
                </SidebarContent>
                <div className="theme-bg">
                    {/* changing menu collapse icon on click */}
                    {menuCollapse ? (
                        <KeyboardDoubleArrowRightIcon onClick={menuIconClick} className="fs-xxl mx-3" />
                    ) : (
                        <KeyboardDoubleArrowLeftIcon onClick={menuIconClick} className="fs-xxl mx-3 fl-r" />
                    )}
                </div>
                <SidebarFooter className="theme-bg">
                    <Menu iconShape="square">
                        <MenuItem onClick={logout}>
                            <FiLogOut style={{ fontSize: '15px', marginRight: "15px", Width: "70px" }} />
                            <span className="ml-3"> Logout</span>
                        </MenuItem>
                    </Menu>
                </SidebarFooter>
            </ProSidebar>
        </div>
    );
};

export default SideBar;
